<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Manage Permissions" bc1="App" bc2="Roles" bc3="Manage Permissions" path="Permissions">
          </Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn btn-gradient-danger btn-sm" @click="$router.back()">
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Permissions</h4>
                </div>
                <div class="card-body" v-show="loading">
                  <div class="col-12 d-flex mt-2  justify-content-center">
                    <div class="spinner-border text-primary"></div>
                  </div>
                </div>
                <div v-show="!loading" class="card-body">



                  <Form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12 mb-2">
                        <template v-for="(itemList,index) in featureList">
                          <h5 class=" mx-1 mb-2 mt-2 text-primary font-italic font-medium-2"
                            style="text-decoration: underline" v-show="itemList['features'].length > 0">
                            {{ itemList.name }}</h5>
                          <template v-for="(feature,featureIndex) in itemList['features']">
                            <div  :class="feature['permissions'].length > 0?'border-secondary badge-glow mb-1 ml-1':''">
                              <div      @click="toggle(index,featureIndex)"   title="Click to view" :id="'headingCollapse_'+itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+'_'+feature.name.replace(/\s/g, '')"
                                class="d-inline-block card-header collapsed " data-toggle="collapse" role="button" :data-target="'#collapse_'+itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+'_'+feature.name.replace(/\s/g, '')" aria-expanded="false"
                                :aria-controls="'collapse_'+itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+'_'+feature.name.replace(/\s/g, '')">
                                <template v-if="feature['permissions'].length > 0" type="button">
                                <button


                                  type="button"
                                  :class="feature.toggle?'btn-danger':'btn-warning'"
                                  class="btn btn-sm btn-icon font-weight-bolder font-medium-1 rounded-circle  waves-effect waves-float waves-light">
                                  {{feature.toggle?'-':'+'}}
                                </button>

                              </template>
                                <h6 class=" font-weight-bolder mx-1 mb-2 mt-2 " :class="feature['permissions'].length > 0?'text-dark':'text-secondary'" style="display:inline">{{ feature.name }} </h6>

                              </div>
                              <div v-if="feature['permissions'].length > 0" class=" custom-control custom-switch  mb-1 d-inline-block mt-1 custom-switch-success ">
                                  <input :id="itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+'_'+feature.name.replace(/\s/g, '')"
                                    type="checkbox" class="custom-control-input" v-model="feature.checkAll" @change="checkAllToogle(index,featureIndex)"  />
                                  <label class=" text-success font-small-1 custom-control-label"
                                    :for="itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+'_'+feature.name.replace(/\s/g, '')">
                                    Check All
                                  </label>
                                </div>


                            </div>

                            <!-- <div v-if="feature['permissions'].length > 0" :id="'collapse_'+itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+'_'+feature.name.replace(/\s/g, '')" role="tabpanel"
                                :aria-labelledby="'headingCollapse_'+itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+'_'+feature.name.replace(/\s/g, '')"
                                class="collapse" aria-expanded="false" style=""> -->
                                <div v-if="feature['permissions'].length > 0"
                                class="collapse " :class="feature.toggle?'show':''" >
                                <div class="card-body">
                                  <div class="custom-control custom-switch mb-1 d-inline-flex mt-1 custom-feature-width"
                                    v-for="(eachPermission,eachPermissionIndex) in feature['permissions']">
                                    <input :id="itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+eachPermissionIndex" type="checkbox"
                                      v-if="typeof(eachPermission.checked) != 'undefined'" class="custom-control-input"
                                      v-model="eachPermission.checked" />
                                    <label class=" text-dark font-small-1 "
                                      :class="typeof(eachPermission.checked) != 'undefined' ? 'custom-control-label':''"
                                      :for="itemList.id+'_'+index+'_'+feature.id+'_'+featureIndex+eachPermissionIndex">
                                      {{
                                      eachPermission.description && eachPermission.description != '' ?
                                      eachPermission.description : eachPermission.end_point
                                      }}
                                    </label>
                                  </div>
                                </div>
                              </div>

                          </template>
                        </template>

                      </div>
                      <div class="col-12 d-flex">
                        <button type="button" class="btn btn-primary mr-1 d-flex " @click="sendCall"
                          :disabled="loading">
                          <Loader :loading="loading" :size="size"></Loader>
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  mounted() {
    this.getAllPermissions()


  },
  data() {
    return {
      loader: false,
      featureList: [],
      tmpLIst: [],
      alreadyCheckedPermissions: {},
      loading: false,
      size: "10px",

    }
  },
  methods: {
    toggle(index,featureIndex){

      let temp = this.featureList
      temp[index]['features'][featureIndex]['toggle'] = temp[index]['features'][featureIndex]['toggle']?false:true
      this.featureList = JSON.parse(JSON.stringify(temp))

    },
    checkAllToogle(index,featureIndex){
      let status = this.featureList[index]['features'][featureIndex]['checkAll']


      let temp = this.featureList
      temp[index]['features'][featureIndex]['permissions'] = temp[index]['features'][featureIndex]['permissions'].map((item, index) => {
        return {
          ...item,
          checked: status?1:0
        }
      })


    },
    sendCall() {

      this.$validator.validateAll().then(valid => {
        if (valid) {

          this.loading = true;
          let groupIds = []
          //extracting ids to send with the request
          this.featureList.forEach(itemList => {

            if (itemList.features.length > 0) {
              itemList.features.forEach((eachFeature, eachFeatureIndex) => {
                if (eachFeature.permissions.length > 0) {
                  eachFeature.permissions.forEach((eachPermission, eachPermissionIndex) => {
                    if (eachPermission.checked) {
                      let rawData = {
                        permissionId: eachPermission.id,
                        featureId: eachFeature.id,
                      }
                      groupIds.push(rawData)
                    }
                  })


                }
              })
            }


          })


          let data = {
            permissionIds: JSON.stringify(groupIds),
            id: parseInt(this.$route.params.roleId)
          }



          this.makeRequest("post", "v1/assign-permissions-to-role", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {

                  this.$router.back()
                }
              }
              this.loading = false;
            }
          );
        }
      });


    },
    getAllPermissions() {
      this.loading = true;
      this.makeRequest('post', 'v1/get-permission', { flag: 'all' }, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.tmpLIst = callResponse.response.data.data
            this.getAlreadySelectedPermissions()
          }
        }
        this.loading = false;
      });
    },
    getAlreadySelectedPermissions() {
      this.loading = true;
      this.makeRequest("post", "v1/get-role-permission", {
        id: parseInt(this.$route.params.roleId)
      }, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = callResponse.response.data.data;
            if (data) {
              if (data.permissions) {
                data.permissions.forEach(v => {
                  this.alreadyCheckedPermissions[v.id] = true
                })
              }
            }

            this.tmpLIst.forEach((eachListItem, index) => {
              if (eachListItem.features.length > 0) {

                eachListItem.features.forEach((eachFeature, eachFeatureIndex) => {
                  this.tmpLIst[index]['features'][eachFeatureIndex]['checkAll'] = false

                  // Check if any permission is checked
                  let anyChecked = false;

                  if (eachFeature.permissions.length > 0) {
                    eachFeature.permissions.forEach((eachPermission, eachPermissionIndex) => {
                      if (typeof (this.alreadyCheckedPermissions[eachPermission.id]) != 'undefined') {
                        eachPermission.checked = true
                        anyChecked = true; // Found at least one checked permission
                      } else {
                        eachPermission.checked = false
                      }

                      this.tmpLIst[index]['features'][eachFeatureIndex]['permissions'][eachPermissionIndex] = eachPermission
                    })
                  }

                  // If any permission is checked, open the accordion
                  this.tmpLIst[index]['features'][eachFeatureIndex]['toggle'] = anyChecked;
                })


              }


            })
            this.featureList = this.tmpLIst



          }
        }
        this.loading = false;
      });
    },
  },

}
</script>
<style scoped>
  .arrow-rotate{
    rotate: 90deg;
  }
</style>

